<div #selectSearch [style.width.px]="computedWidth" [ngClass]="selectClass" class="select-search">
  <span>{{ '' + selectedText(selected) | translate }}</span>
  <mat-icon>{{ dropdownIcon() }}</mat-icon>
</div>
<div
  class="dropdown-content"
  [style.width]="dropdownWidth"
  [style.min-width.px]="computedWidth"
  [ngClass]="selectClass"
  [hidden]="!isSelecting"
  (click)="$event.stopPropagation()"
>
  <va-search-box *ngIf="showSearch" (update)="searchTerm = $event" />
  <ul>
    <li *ngFor="let option of filteredOptions(searchTerm)" (click)="optionClicked(option, $event)">
      {{ '' + optionText(option) | translate }}
    </li>
  </ul>
</div>
